export * from './normalizeSequence';
